import { safeStorageGet, safeStorageSet } from '../../modules/safe-storage.js';

let pagedViewPreference;

export function prefersPagedView() {
  return pagedViewPreference ?? (safeStorageGet('pm_paged_view') === '1');
}

export function setPagedViewPreference(paged) {
  // Keep the selected mode when storage rejects a write but retains an old value.
  pagedViewPreference = safeStorageSet('pm_paged_view', paged ? '1' : '0') ? undefined : paged;
}
